// checkHealth is the connectivity probe used by ConnectionWatcher. It
// intentionally bypasses apiFetch (and therefore the 401 -> /login redirect)
// because the overlay must be able to recover from a transient network
// failure without yanking an editor away from their session.
export async function checkHealth(): Promise<boolean> {
  try {
    const res = await fetch('/api/health', { credentials: 'include' });
    return res.ok;
  } catch {
    return false;
  }
}
